import { render, staticRenderFns } from "./studyScheme.vue?vue&type=template&id=41c90632&scoped=true"
import script from "./studyScheme.vue?vue&type=script&lang=js"
export * from "./studyScheme.vue?vue&type=script&lang=js"
import style0 from "./studyScheme.vue?vue&type=style&index=0&id=41c90632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c90632",
  null
  
)

export default component.exports